import { CLAIM_PROJECT_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'

export default recordId => pushRouteClient({
	routeId: CLAIM_PROJECT_ROUTE_ID,
	routeParams: { recordId },
})
